import { render } from "./Electro3Home.vue?vue&type=template&id=25434caf&scoped=true&class=banner"
import script from "./Electro3Home.vue?vue&type=script&lang=js"
export * from "./Electro3Home.vue?vue&type=script&lang=js"

import "./Electro3Home.vue?vue&type=style&index=0&id=25434caf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25434caf"]])

export default __exports__